


























































































import { UseModal } from "@/components/root/modal";
import Vue from "vue";
import { CsvScheduleItem } from "../data/csv/model";
import { state } from "../data/csv/state.csv";
import { ReportScheduleOption } from "../data/pdf/model";
import EmailListModalVue from "./EmailListModal.vue";
import ScheduledButtons from "./ScheduledButtons.vue";
export default Vue.extend({
  components: { ScheduledButtons },
  setup() {
    const {
      scheduled_reports,
      remove_scheduled_report,
      update_scheduled_report,
    } = state;

    const set_selected_schedule = async (
      report: CsvScheduleItem,
      schedule: ReportScheduleOption
    ) => {
      if (schedule == "none") {
        const res = await UseModal().showSimple({
          title: "Remove Scheduled Report",
          desc: "Are you sure you want to remove the report?",
          cancelBtnText: "Cancel",
          submitBtnText: "Remove",
          is_destructive: true,
        });
        if (res.type == "canceled") {
          return;
        }
        remove_scheduled_report(report.ruleId);
      } else {
        update_scheduled_report({
          ...report,
          timeFrame: schedule,
        });
      }
    };

    const remove_email = async (report: CsvScheduleItem, email: string) => {
      const res = await UseModal().showSimple({
        title: "Remove Email",
        desc: "Are you sure you want to remove this email?",
        cancelBtnText: "Cancel",
        submitBtnText: "Remove",
        is_destructive: true,
      });
      if (res.type == "success") {
        update_scheduled_report({
          ...report,
          subscribers: report.subscribers.filter((e) => e != email),
        });
      }
    };

    const open_email_list_modal = async (report: CsvScheduleItem) => {
      const res = await UseModal().show(EmailListModalVue, {
        emails: report.subscribers,
      });
      if (res.type == "success") {
        update_scheduled_report({
          ...report,
          // @ts-ignore
          subscribers: res.msg,
        });
      }
    };
    return {
      scheduled_reports,
      set_selected_schedule,
      open_email_list_modal,
      remove_email,
    };
  },
});
